export const NORMAL = 56;
export const PART = 28;

const HEIGHT = 38;

export const elementHeights = {
  28: HEIGHT / 2,
  56: HEIGHT,
};

// this was generated with: ./generateElementWidths.js
export const elementWidths = {
  28: {
    '2': 15.618182182312012,
    '3': 15.618182182312012,
    '4': 15.618182182312012,
    '5': 15.618182182312012,
    '6': 15.618182182312012,
    '7': 15.618182182312012,
    '8': 15.618182182312012,
    '9': 15.618182182312012,
    '+': 16.399999618530273,
    '-': 9.363636016845703,
    '2+': 32.01818084716797,
    '3+': 32.01818084716797,
    '4+': 32.01818084716797,
    '5+': 32.01818084716797,
    '6+': 32.01818084716797,
    '7+': 32.01818084716797,
    '8+': 32.01818084716797,
    '9+': 32.01818084716797,
    '2-': 24.9818172454834,
    '3-': 24.9818172454834,
    '4-': 24.9818172454834,
    '5-': 24.9818172454834,
    '6-': 24.9818172454834,
    '7-': 24.9818172454834,
    '8-': 24.9818172454834,
    '9-': 24.9818172454834,
  },
  56: {
    C: 40.581817626953125,
    O: 43.70909118652344,
    Es: 65.56363677978516,
    Sb: 68.7272720336914,
    Mo: 78.0545425415039,
    Y: 37.47272872924805,
    Sg: 68.7272720336914,
    Ca: 71.83636474609375,
    No: 71.83636474609375,
    Hf: 56.20000076293945,
    Md: 78.0545425415039,
    Cu: 71.83636474609375,
    Al: 49.9636344909668,
    He: 71.83636474609375,
    Am: 84.2727279663086,
    Rf: 56.20000076293945,
    Sn: 68.7272720336914,
    Zn: 65.58181762695312,
    Pr: 56.181819915771484,
    Bk: 65.56363677978516,
    Pa: 68.7272720336914,
    Rh: 71.83636474609375,
    Ho: 71.83636474609375,
    Gd: 74.96363830566406,
    Ne: 71.83636474609375,
    B: 37.47272872924805,
    H: 40.581817626953125,
    Ba: 68.7272720336914,
    Mn: 78.0545425415039,
    Lr: 49.9636344909668,
    Lu: 62.509090423583984,
    Os: 71.80000305175781,
    Fl: 46.818180084228516,
    P: 37.47272872924805,
    Be: 68.7272720336914,
    Ra: 71.83636474609375,
    Sm: 84.2727279663086,
    Re: 71.83636474609375,
    Cm: 87.38182067871094,
    Fe: 65.58181762695312,
    Bi: 49.9636344909668,
    Hs: 68.6727294921875,
    Pt: 53.09090805053711,
    In: 46.87272644042969,
    Kr: 56.181819915771484,
    Ce: 71.83636474609375,
    Ir: 34.327274322509766,
    Nh: 71.83636474609375,
    Cd: 71.83636474609375,
    Dy: 68.6727294921875,
    Te: 59.345455169677734,
    Fr: 53.0363655090332,
    Nd: 71.83636474609375,
    Nb: 71.83636474609375,
    Ac: 65.56363677978516,
    V: 37.47272872924805,
    Ar: 56.181819915771484,
    Ta: 59.345455169677734,
    Rn: 71.83636474609375,
    F: 34.327274322509766,
    Db: 71.83636474609375,
    Bh: 68.7272720336914,
    Mg: 78.0545425415039,
    Ds: 68.6727294921875,
    Si: 49.9636344909668,
    At: 53.09090805053711,
    Tb: 65.58181762695312,
    Ts: 56.181819915771484,
    Ge: 74.96363830566406,
    W: 53.0363655090332,
    Pm: 84.2727279663086,
    Ga: 74.96363830566406,
    Er: 56.181819915771484,
    Tc: 56.181819915771484,
    Rb: 71.83636474609375,
    Co: 71.83636474609375,
    Xe: 68.7272720336914,
    Lv: 59.345455169677734,
    Pb: 68.7272720336914,
    Eu: 68.7272720336914,
    S: 37.47272872924805,
    Li: 43.745452880859375,
    Tl: 46.818180084228516,
    Cf: 56.20000076293945,
    Np: 71.83636474609375,
    Zr: 53.0363655090332,
    Og: 74.96363830566406,
    U: 40.581817626953125,
    La: 62.509090423583984,
    K: 37.47272872924805,
    Sc: 65.56363677978516,
    Ru: 71.83636474609375,
    Ti: 44.727272033691406,
    Hg: 71.83636474609375,
    Rg: 71.83636474609375,
    Mc: 74.89090728759766,
    Sr: 56.181819915771484,
    Po: 68.7272720336914,
    Pu: 68.7272720336914,
    Au: 68.7272720336914,
    Se: 68.7272720336914,
    Fm: 81.12727355957031,
    Cn: 71.83636474609375,
    Tm: 81.12727355957031,
    Yb: 68.7272720336914,
    N: 40.581817626953125,
    Th: 65.58181762695312,
    Ni: 53.07272720336914,
    Cl: 53.07272720336914,
    Na: 71.83636474609375,
    Ag: 68.7272720336914,
    Br: 56.181819915771484,
    Cr: 59.29090881347656,
    Cs: 68.6727294921875,
    As: 65.56363677978516,
    Pd: 68.7272720336914,
    I: 15.618182182312012,
    Mt: 62.418182373046875,
  },
};
